export default "__VITE_ASSET__sqNYhuve__"